// I don't think this is used
export const auth0Config = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  scope: process.env.REACT_APP_AUTH0_GMAIL_SCOPE,
  domain: process.env.REACT_APP_AUTH0_DOMAIN
};

export const posthogConfig = {
  apiKey: process.env.REACT_APP_POSTHOG_KEY,
  apiHost: process.env.REACT_APP_POSTHOG_HOST,
  options: {
    capture_pageview: false, // Disable automatic pageview capture, we'll do it manually
    capture_pageleave: true, // Capture when user leaves the page
    loaded: (posthog) => {
      if (process.env.NODE_ENV === "development") posthog.debug();
    }
  }
};

// read and move
// scope:
//   'openid profile email https://www.googleapis.com/auth/gmail.labels https://www.googleapis.com/auth/gmail.readonly',

// read, move, and send emails
// scope: 'openid profile email https://www.googleapis.com/auth/gmail.labels https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send',
